import React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import SearchIcon from '@mui/icons-material/Search';

const selectSx = {
  height: '40px',
  borderRadius: '8px',
  fontSize: '0.875rem',
  minWidth: 170,
  backgroundColor: '#fff',
  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E0E0E0' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#BDBDBD' },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'primary.main' },
};

const textSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    backgroundColor: '#fff',
    height: '40px',
    '& fieldset': { borderColor: '#E0E0E0' },
    '&:hover fieldset': { borderColor: '#BDBDBD' },
    '&.Mui-focused fieldset': { borderColor: 'primary.main' },
  },
  '& input': { fontSize: '0.875rem' },
};

/**
 * WhatsAppFilters - Barra de filtros da tela "WhatsApp" (Admin Geral)
 * @param {Object} props
 * @param {string} props.searchInput
 * @param {Function} props.onSearchChange
 * @param {number} props.days
 * @param {Function} props.onDaysChange
 * @param {string} props.origin - all|platform|own
 * @param {Function} props.onOriginChange
 * @param {boolean} props.includeTest
 * @param {Function} props.onIncludeTestChange
 * @param {string} props.sort - sends|blocked|last_send|name
 * @param {Function} props.onSortChange
 */
function WhatsAppFilters({
  searchInput,
  onSearchChange,
  days,
  onDaysChange,
  origin,
  onOriginChange,
  includeTest,
  onIncludeTestChange,
  sort,
  onSortChange,
}) {
  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        flexWrap: 'wrap',
        borderBottom: '1px solid #E8ECF0',
        bgcolor: '#fff',
      }}
    >
      <TextField
        size="small"
        placeholder="Buscar empresa"
        value={searchInput}
        onChange={(e) => onSearchChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: 'text.disabled', fontSize: 18 }} />
            </InputAdornment>
          ),
        }}
        sx={{ flex: 1, minWidth: 220, maxWidth: { sm: 320 }, ...textSx }}
      />

      <Select size="small" value={days} onChange={(e) => onDaysChange(Number(e.target.value))} sx={selectSx}>
        <MenuItem value={7}>Últimos 7 dias</MenuItem>
        <MenuItem value={15}>Últimos 15 dias</MenuItem>
        <MenuItem value={30}>Últimos 30 dias</MenuItem>
      </Select>

      <Select size="small" value={origin} onChange={(e) => onOriginChange(e.target.value)} sx={selectSx}>
        <MenuItem value="all">Todas as origens</MenuItem>
        <MenuItem value="platform">Plataforma</MenuItem>
        <MenuItem value="own">Número próprio</MenuItem>
      </Select>

      <Select size="small" value={sort} onChange={(e) => onSortChange(e.target.value)} sx={selectSx}>
        <MenuItem value="sends">Ordenar por envios</MenuItem>
        <MenuItem value="blocked">Ordenar por bloqueados</MenuItem>
        <MenuItem value="last_send">Ordenar por último envio</MenuItem>
        <MenuItem value="name">Ordenar por nome</MenuItem>
      </Select>

      <FormControlLabel
        control={<Switch checked={includeTest} onChange={(e) => onIncludeTestChange(e.target.checked)} size="small" />}
        label={<Typography variant="body2">Incluir empresas de teste</Typography>}
        sx={{ ml: { xs: 0, sm: 'auto' } }}
      />
    </Box>
  );
}

export default WhatsAppFilters;
